import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { FleetActions } from '../../../actions';
import SubnavBar from '../../../components/SubnavBar';
import TitleBar from '../../../components/TitleBar';
import Add from '../../../components/Fleet/Units/Add';

class Units extends Component {
  constructor(props) {
    super(props);

    this.saveUnit = this.saveUnit.bind(this);
  }
  goBack = () => {
    browserHistory.push('/fleet/units');
  }
  saveUnit(values) {
    const { dispatch } = this.props;

    return dispatch(FleetActions.saveUnit(values)).then((response) => {
      browserHistory.push('/fleet/units');
    });

  }
  render() {
    const subnavItems = []
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} back={this.goBack} />
          <TitleBar title="Add New Unit" />
          <div className="row">
            <div className="col s12">
              <Add onSubmit={this.saveUnit} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Units);



// WEBPACK FOOTER //
// ./src/containers/Fleet/Units/New.js